import { rem } from 'polished'

const RADIUS_BASE = 8

// 4px
export const RADIUS_0 = rem(RADIUS_BASE / 2)
// 8px
export const RADIUS_1 = rem(RADIUS_BASE)
// 16px
export const RADIUS_2 = rem(RADIUS_BASE * 2)
// 24px
export const RADIUS_3 = rem(RADIUS_BASE * 3)
// 32px
export const RADIUS_4 = rem(RADIUS_BASE * 4)
// 48px
export const RADIUS_6 = rem(RADIUS_BASE * 6)
